<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <label for="form-organization-position" class="control-label">{{ inputLabel }}</label>
    <select
      v-model="inputValue"
      :disabled="disabled"
      id="form-organization-position"
      class="form-control"
      @change="emit($event)"
    >
      <option value="without-authority">Без доверенности</option>
      <option value="with-authority">По доверенности</option>
      <option v-if="organizationSubdivisionsExists" value="supervisor-subdivision">Руководитель подразделения</option>
    </select>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import organizationSectionMixin from '../../../../mixins/application-form/organizationSectionMixin'
import organizationInputMixin from '../../../../mixins/application-form/organizationInputMixin'

export default {
  name: 'OrganizationManagerAuthorityInput',

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    organizationSectionMixin,
    organizationInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Полномочия подписанта'
    },

    inputName: {
      default: 'authority_of_manager'
    },

    organizationSubdivisionsExists: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    this.$emit('change')
  }
}
</script>
